import Linkify from "linkify-react";

export default function MessageText({ text }) {
  return (
    <Linkify
      options={{
        target: "_blank",
        rel: "noopener noreferrer",
        className: "chat-link",
      }}
    >
      {text}
    </Linkify>
  );
}